import { fetchWrapper } from "@/helpers";

const BASE_URL = `${import.meta.env.VITE_API_URL}`;

const contextQuery = (context) => {
  const params = new URLSearchParams({ context_type: context.type });
  if (context.id) params.set("context_id", context.id);
  if (context.itemId) params.set("item_id", context.itemId);
  return params.toString();
};

const fetchComments = async (
  distributionId,
  participantTimepointId,
  context,
) => {
  return await fetchWrapper.get(
    `${BASE_URL}/${distributionId}/pt/${participantTimepointId}/review-comments?${contextQuery(context)}`,
  );
};

const createComment = async (
  distributionId,
  participantTimepointId,
  context,
  languageId,
  body,
) => {
  return await fetchWrapper.post(
    `${BASE_URL}/${distributionId}/pt/${participantTimepointId}/review-comments`,
    {
      context_type: context.type,
      context_id: context.id ?? null,
      item_id: context.itemId ?? null,
      language_id: languageId ?? null,
      body,
    },
  );
};

export const reviewService = { fetchComments, createComment };
